<style> 
  .SelectSize {
      background-color: #007bff;
      border: solid #007bff 2px;
      color: white;
  }  
  .NotSelectSize {
      background-color: #c0c4cc59;
      border: solid #c0c4cc59 2px;
      color: black;
  }  
</style>
<template>
  <!--begin::Modal - View Users-->
  <div
    class="modal fade"
    id="kt_modal_view_users"
    tabindex="-1"
    aria-hidden="true"
    ref="searchProductModalRef"
  >
    <!--begin::Modal dialog-->
    <div class="modal-dialog modal-dialog-centered mw-1000px ">
      <!--begin::Modal content-->
      <div class="modal-content">
        <loading
          v-model:active="isLoading"
          :can-cancel="true"
          :is-full-page="false"
        />
        <!--begin::Modal header-->
        <div class="modal-header pb-0 border-0 justify-content-between" style="padding: 0.75rem 1.75rem;">
          <!--begin::Close-->

          <h1 class="mb-3">เลือกสินค้า</h1>
          <div
            class="btn btn-sm btn-icon btn-active-color-primary"
            data-bs-dismiss="modal"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
          <!--end::Close-->
        </div>
        <!--begin::Modal header-->

        <!--begin::Modal body-->
        <div class="modal-body pb-0">
          <!--begin::Heading-->

          <!--end::Heading-->
          <!-- <form data-kt-search-element="form" class="w-100 position-relative mb-5" autocomplete="off"> -->
          <div class="row">
            <div class="col-8">
              <el-input
                placeholder="Type something"
                prefix-icon="bi bi-search fs-4 ps-1 "
                v-model="searchText"
                clearable
              >
              </el-input>
            </div>
            <div class="offset-1 col-2 d-flex align-items-center" v-if="!isSR">
              <span class="fs-5 me-3"> แสดง </span>
              <el-checkbox v-model="readyForSale"  label="สต๊อก > 0" size="large" />
            </div>
            <!-- <div class="offset-1 col-2 d-flex align-items-center" v-else>
              <span class="fs-5 me-3"> แสดงสต๊อก = 0 </span>
            </div> -->
          </div>
          <!-- </form> -->
          <!--begin::Users-->
          <div class="row mt-5">
          <div class="col-12">
            <div style="padding: 4px; float: left;" >
              <label style="font-weight: bold;">Size : </label>&nbsp;
              <span v-bind:class="[selectedSize == 'All' ? 'SelectSize' : 'NotSelectSize']" style="border-radius: 15px; cursor: pointer; padding: 2px 8px;" @click="selectedSizeHandler('All')">
                <span style="font-size: 15px; padding: 5px 0px;">All</span>
              </span>
            </div>
            <div v-for="size in sizes" :key="size.id" style="padding: 4px; float: left; margin-bottom: 0px;">
              <span style="border-radius: 15px; padding: 2px 8px; cursor: pointer;" v-bind:class="[selectedSize == size.name ? 'SelectSize' : 'NotSelectSize']" @click="selectedSizeHandler(size.name)">
                <span style="font-size: 15px; padding: 5px 0px;">{{size.name}}</span>
              </span>
            </div>
          </div> 
          </div>         
          <div class="row mt-3" >
            <!--begin::List-->
            <div class="col-3">
              <div class="mt-10">
                <ul class="list-group" style="height: calc(100vh - 28rem); overflow: scroll; ">
                  <li class="list-group-item list-group-item-action"
                    :class="{active: selectedCategory && selectedCategory.productCategoryCode == category.productCategoryCode}"
                    @click="selectCategoryHandler(category)" 
                    v-for="category in productCategoryList.filter(c => c.proCateIsSelling)" 
                    :key="category.productCategoryCode">
                    {{category.productCategoryName}}
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-9">
              <div class="mh-375px me-n7 pe-7">
                <el-table
                  :data="showProduct"
                  stripe
                  ref="tbProductSelect"
                  @selection-change="handleProductSelectionChange"
                  style="width: 100%"
                  height="360px"
                >
                  <el-table-column type="index" prop="productID" :disabled=true width="40">
                    <template #default="scope">
                      <div class="d-flex align-items-center">
                      <input type="checkbox" :disabled="isProductDisabled(scope.row)"
                        :checked="selected.includes(scope.row.productID)"
                        @change="() => onSelectProductCheckboxChangeHandler(scope.row.productID)"/>
                        </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="productCode" label="รหัสสินค้า" width="150" v-if="isAdmin"  sortable>
                    <template #default="scope">
                      <span style="cursor: pointer;" >{{ scope.row.productCode }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column sortable prop="productName" label="สินค้า">
                  </el-table-column>
                  <el-table-column
                    sortable
                    prop="stockQuantity"
                    label="คงเหลือ"
                    align="right"
                    width="100"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="stockQuantity2S"
                    align="right"
                    width="120"
                    sortable
                  >
                    <template #header>
                      <span>สต็อก 2S</span>
                      <el-tooltip
                        v-if="isSR"
                        class="item"
                        effect="dark"
                        placement="top"
                        content="สต็อก 2S, ค้างรับ 2S หรือมีแผนผลิต"
                      >
                        <i class="fas fa-info-circle ms-1" style="cursor: pointer;"></i>
                      </el-tooltip>
                    </template>
                    <template #default="scope">
                      <div v-if="scope.row.stockQuantity2S > 0">                
                        <div v-if="scope.row.planFinDate != null && scope.row.planFinDate != '0001-01-01T00:00:00'">
                          <el-tooltip
                          class="item"
                          effect="dark"
                          :content="getPlanFinDate(scope.row)"
                          placement="top"
                          :disabled="!scope.row.productIsSteel"
                          >              
                          <span style="cursor: pointer;">{{ numberWithCommas(scope.row.stockQuantity2S, 0) }} <i class="fas fa-calendar-day"></i></span>
                          </el-tooltip>                     
                        </div>
                        <div v-else>{{ numberWithCommas(scope.row.stockQuantity2S, 0) }}</div>                
                      </div>
                      <div v-else>
                        <div v-if="scope.row.planFinDate != null && scope.row.planFinDate != '0001-01-01T00:00:00'">
                          <el-tooltip
                          class="item"
                          effect="dark"
                          :content="getPlanFinDate(scope.row)"
                          placement="top"
                          :disabled="!scope.row.productIsSteel"
                          >              
                          <span style="cursor: pointer;">0 <i class="fas fa-calendar-day"></i></span>
                          </el-tooltip>                     
                        </div>
                        <div v-else>0</div>
                      </div>             
                    </template>
                  </el-table-column>
                  <el-table-column
                    sortable
                    prop="productWeight"
                    label="น้ำหนัก"
                    align="right"
                    width="100"
                  >
                    <template #default="scope">
                        <span>
                          {{ numberWithCommas(scope.row.productWeight, 0) }}
                        </span>            
                    </template>
                  </el-table-column>
                  <el-table-column
                    sortable
                    prop="sellingPrice"
                    label="ราคา"
                    align="right"
                    width="100"
                  >
                    <template #default="scope">
                        <span>
                          {{ numberWithCommas(scope.row.sellingPrice, 0) }}
                        </span>            
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <!--end::List-->
          </div>
          <!--end::Users-->
        </div>
        <!--end::Modal body-->
        <div class="modal-footer border-0">
          <button type="button" class="btn btn-secondary" @click="hide">
            กลับ
          </button>
          <button type="button" class="btn btn-primary ms-5" @click="submit">
            ยืนยัน
          </button>
        </div>
      </div>
      <!--end::Modal content-->
    </div>
    <!--end::Modal dialog-->
  </div>
  <!--end::Modal - View Users-->
</template>

<script>
import { Modal } from "bootstrap";
import ApiService from "@/core/services/ApiService";
import { numberWithCommas, formatDateFromISO } from "@/utils";
import Loading from "vue-loading-overlay";
import { boolean } from 'yup/lib/locale';

export default {
  components: { Loading },
  props: {
    modelValue: Array,
    isSR:Boolean
  },
  data() {
    return {
      products: [],
      modal: null,
      searchText: null,
      selected: [],
      isLoading: false,
      readyForSale: this.isSR?false:true,
      productCategoryList: [],
      sizes: [],
      selectedSize: "All",      
      selectedCategory: null,
    };
  },
  mounted() {
    this.modal = new Modal(this.$refs.searchProductModalRef);

  },
  computed: {
    showProduct() {
      const regex = new RegExp(this.searchText ? this.searchText :  "", "gi");
      return this.products.filter((product) => {
        if(this.readyForSale && product.stockQuantity <= 0) {
          return false;
        }
        return ((product.productCode.match(regex)  || product.productName.match(regex))
                && (!this.selectedCategory || product.productCategoryID == this.selectedCategory.productCategoryCode) 
                && (product.prosizeGroup == (this.selectedSize.trim() != "All" ? this.selectedSize.trim() : product.prosizeGroup))) ;
      });
    },
    isAdmin() {      
      return this.$store.getters.isAdmin
    },
  },
  methods: {
    show() {
      this.modal.show();
      this.selected = [];
      this.getCategoryList();
      this.getProducts();
    },
    hide() {
      this.modal.hide();
    },
    getProducts: async function () {
      try {
        this.isLoading = true;
        const { data } = await ApiService.query("products", {params: {"markup": true}});
        this.products = data.filter(this.checkNonSelectedProduct);
        this.products.forEach(p => p.maxPrice = p.sellingPrice);
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    checkNonSelectedProduct(product) {
      return (
        !this.modelValue ||
        !this.modelValue.find((p) => p.productID == product.productID)
      );
    },
    handleProductSelectionChange(val) {
      this.selected = val;
    },
    onSelectProductCheckboxChangeHandler(val) {
      if(this.selected.find(v => v == val))
      {
        this.selected = this.selected.filter(v => v != val)
      } else  {
        this.selected.push(val)
      }
    },
    submit() {
      // console.log(this.modelValue);
      let result = this.modelValue || [];
      this.products.filter( p => this.selected.includes(p.productID)).forEach((product) => {
        if (this.checkNonSelectedProduct(product)) {
          result.push({
            ...product,
            quantity: 1,
            price: product.priceStandard,
            returnQuan: null,
          });
        }
      });
      result.sort((a, b) => {
        if(a.productCode > b.productCode) return 1
        if(a.productCode < b.productCode) return -1
        return 0
      })
      this.$emit("update:modelValue", result);
      this.hide();
    },
    getCategoryList: async function() {
      try {
          // console.log(this.currentUser)
        const { data } = await ApiService.query("productcategorys/partner")

        this.productCategoryList = data;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    selectCategoryHandler(category) {
      this.selectedCategory = this.selectedCategory && this.selectedCategory.productCategoryCode == category.productCategoryCode ? null : category
      this.getSize(this.selectedCategory && this.selectedCategory.productCategoryCode == category.productCategoryCode ? category.productCategoryCode : null);
    },
    getSize(category) {
        ApiService.get("categories/" + category + "/sizes")
            .then( res => {
            this.sizes = res.data
            })
            .catch(() => {          
            this.$swal('error', 'error', 'error')
        })    
        this.selectedSize = "All";
    },  
    selectedSizeHandler(sizename){
        this.selectedSize = sizename;   
    },  
    getPlanFinDate(product){
      return "แผนผลิต: " + formatDateFromISO(product.planFinDate);
    },
    isProductDisabled(product) {
      if (!this.isSR) {
        return product.stockQuantity <= 0;
      }
      if (product.stockQuantity > 0) {
        return false;
      }
      const hasPlanFinDate = product.planFinDate != null && product.planFinDate != '0001-01-01T00:00:00';
      return (product.stockQuantity2S + product.onTruckNotGet) <= 0 && !hasPlanFinDate;
    },
    numberWithCommas,
    formatDateFromISO
  },
};
</script>
